import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { lighten } from 'polished';

import theme from '@styles/theme';
import { DataValueType } from '@utils/types';

import { FlexBox } from '@components/styled/StyledComponents';

type FilterButtonsProps = {
    setSelectedFilter: Dispatch<SetStateAction<number>>;
    selectedFilter: number;
    options: DataValueType[];
    margin?: string;
};
const FilterButtons = ({
    selectedFilter,
    setSelectedFilter,
    options,
    margin = '0 0 32px'
}: FilterButtonsProps) => {
    return (
        <FlexBox $gap={8} $margin={margin}>
            {options.map((option, index) => (
                <Wrapper key={`${index}-${option.title}`}>
                    <Input
                        type="radio"
                        id={`${index}filter`}
                        name="filter"
                        value={option.value}
                        onChange={(e) => setSelectedFilter(+e.target.value)}
                        checked={option.value === selectedFilter}
                    />
                    <Label htmlFor={`${index}filter`}>{option.title}</Label>
                </Wrapper>
            ))}
        </FlexBox>
    );
};

export default FilterButtons;

const Wrapper = styled.div``;

const Label = styled.label`
    padding: 8px 16px;
    font-size: 16px;
    color: ${theme.colors.deepGrayFontColor};
    background-color: ${theme.colors.whiteColor};
    border: ${theme.colors.ultraLightGrayBorder} 1px solid;
    border-radius: 4px;
    transition: all 0.25s;
    cursor: pointer;
    &:hover {
        background-color: ${theme.colors.lightGrayHoverColor};
    }
`;

const Input = styled.input`
    display: none;
    &:checked ~ label {
        color: ${theme.colors.whiteColor};
        background-color: ${theme.colors.blackColor};
        border: none;
        z-index: 10;
        &:hover {
            background-color: ${lighten(0.2, theme.colors.blackColor)};
        }
    }
`;
